import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ResultsSection() {
  const results = ['Menos ruido mental en la noche', 'Más facilidad para empezar cosas pequeñas', 'Mejor sueño (por estructura, no por suerte)', 'Menos recaídas largas, más regresos rápidos', 'Más respeto interno'];
  return <section className="py-12 px-4 bg-matrix-bg" data-id="element-294">
      <div className="max-w-3xl mx-auto" data-id="element-295">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-matrix-surface/30 p-8 md:p-12 rounded-2xl border border-matrix-dim" data-id="element-296">
          <h2 className="text-2xl md:text-3xl font-bold text-matrix-orange mb-2 text-center" data-id="element-297">
            Resultados que la gente suele notar
          </h2>
          <p className="text-matrix-muted text-center mb-6 italic" data-id="element-298">
            (sin prometer milagros)
          </p>

          <ul className="space-y-4" data-id="element-299">
            {results.map((result, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-center gap-4 text-lg text-matrix-text/90" data-id="element-300">
                <CheckCircle2 className="w-5 h-5 text-matrix-primary shrink-0" data-id="element-301" />
                <span data-id="element-302">{result}</span>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}